export interface PopupHTMLParams {
  name: string;
  subtitle?: string;
}

export const buildStationPopupHTML = (params: PopupHTMLParams): string => {
  if (params.subtitle) {
    return `<div>
      <small class="text-gray-600 leading-none block mb-2 text-[10px] font-bold uppercase">${params.subtitle}</small>
      <h2 class="text-black text-xl font-bold leading-none mb-0 pb-0">${params.name}</h2>
    </div>`;
  }

  return `<div>
    <small class="text-gray-600 leading-none block mb-4 text-xs uppercase">Estación</small>
    <h2 class="text-black text-xl font-bold leading-none mb-0 pb-0">${params.name}</h2>
  </div>`;
};

export interface MarkerCoordParams {
  lat: number;
  lng: number;
}

export const buildMarkerCoords = (
  params: MarkerCoordParams
): { lng: number; lat: number } => {
  return { lng: params.lng, lat: params.lat };
};
